"use client";

import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useAuthContext } from "../../../../context/AuthContext";
import { ReferralActions } from "./ReferralActions";


const Profile = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const [userName, setUserName] = useState<string>("Usuario");
  const [referralCode, setReferralCode] = useState<string>("MH12345");
  const { logout } = useAuthContext();

  useEffect(() => {
    // Obtener el nombre del usuario desde localStorage
    const storedName = localStorage.getItem("name") || "Usuario";
    const storedCode = localStorage.getItem("multyhealth_code") || "MH12345";
    setUserName(storedName);
    setReferralCode(storedCode);
  }, []);



  return (
    <>
      <Dropdown className="admin-profile">
        <Dropdown.Toggle className="d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor">
          <div className="flex-shrink-0">
            <img
              className="rounded-circle wh-40 administrator"
              src="/images/logo-icon.svg"
              alt="usuario"
              width={40}
              height={40}
            />
          </div>

          <div className="flex-grow-1 ms-2">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-none d-xxl-block">
                <div className="d-flex flex-column align-content-center">
                  <h3>{userName}</h3>
                  <span className="fs-12">{referralCode}</span>
                </div>
              </div>
            </div>
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu className="border-0 bg-white dropdown-menu-end">
          <div className="d-flex align-items-center info">
            <div className="flex-shrink-0">
              <img
                className="rounded-circle wh-30 administrator"
                src="/images/logo-icon.svg"
                alt="usuario"
                width={30}
                height={30}
              />
            </div>
            <div className="flex-grow-1 ms-2">
              <h3 className="fw-medium">{userName}</h3>
              <span className="fs-12">{referralCode}</span>

            </div>
          </div>
          <div className="d-none d-md-block">
            <div className="mt-3">
              <ReferralActions referralCode={referralCode} />
            </div>
          </div>
          <ul className="admin-link ps-0 mb-0 list-unstyled">
            <li>
              <Link
                to="/my-profile"
                className={`dropdown-item d-flex align-items-center text-body ${pathname === "/my-profile" ? "activeLink" : ""
                  }`}
              >
                <i className="material-symbols-outlined">account_circle</i>
                <span className="ms-2">Mi Perfil</span>
              </Link>
            </li>

            <li>
              <button
                type="button"
                className="dropdown-item d-flex align-items-center text-body"
                onClick={() => logout()}
              >
                <i className="material-symbols-outlined">logout</i>
                <span className="ms-2">Cerrar Sesión</span>
              </button>
            </li>
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};


export default Profile;
